import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { TextCellContent } from './TextCellContent';

export const TextCell = <TType extends RowData, TValue>({ getValue }: CellContext<TType, TValue>) => {
  const cellValue = getValue<string>();

  return <TextCellContent value={cellValue} />;
};
